export default "__VITE_ASSET__CuojS62e__"